export enum SsoProfileEnum {
  POINT_OF_SALES_BUYER = "point_of_sales_buyer",
  INDUSTRY_EMPLOYEE = "industry_employee",
  RETAILER = "retailer",
  TRADE_MANAGER = 'trade_manager',
}